export enum EBannerCategory {
  BANNER = 'BANNER',
  NEWS = 'NEWS',
  ADVICE = 'ADVICE',
  ONBOARDING_TUTORIAL = 'ONBOARDING_TUTORIAL',
}

export type TBannerCategory = keyof typeof EBannerCategory;
